import { css, useTheme } from "@emotion/react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Button = ({ color, children, to, stylesOverride, ...props }) => {
  const theme = useTheme();
  const Tag = createTagComponent(to);

  const style = css(`
    justify-content: center;
    align-items: center;

    display: flex;
    width: auto;
    min-height: 4rem;
    padding: 0.6rem 2rem;

    font-family: ${theme.typography.button.fontFamily};
    font-size: 1.6rem;
    font-weight: 400;
    text-decoration: none;
    text-align: center;
    text-transform: capitalize;
    color: ${theme.colors.text[color][theme.variant]};

    background-color: ${theme.colors.background[color][theme.variant]};
    border: 0.2rem solid;
    border-color: ${theme.colors.text[color][theme.variant]};
    
    overflow: hidden;
    cursor: pointer;

    &.is-sm {
      font-size: 1.4rem;
    }

    &.is-lg {
      font-size: 1.8rem;
    }
  `);

  return children ? (
    <Tag css={[style, stylesOverride]} to={Tag === Link ? to : null} href={Tag === 'a' ? to : null} {...props}>
      {children}
    </Tag>
  ) : null;
};

const createTagComponent = (path) => {
  if(path === undefined){
    return "button";
  }
  const absolutePathPattern = /^https?:\/\//i;
  if(absolutePathPattern.test(path))
  {
    return "a";
  }

  return Link;
}

Button.defaultProps = {
  color: "brand",
  to: undefined,
  type: "button",
  stylesOverride: {}
};

Button.propTypes = {
  to: PropTypes.string,
  color: PropTypes.oneOf([
    "brand",
    "primary",
    "basedRev",
    "secondary",
    "success",
    "error",
    "warning",
    "info",
  ]),
  children: PropTypes.node,
  type: PropTypes.string,
  stylesOverride: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
};

export default Button;
